export class BaseEvent {
    constructor(eventType, payload) {
        this.eventType = eventType;
        this.payload = payload;
    }
}
